import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MINUTES_IN_DAY, MINUTES_IN_HOUR } from '@repo/constants';
import { getMinutesInCurrentMonth } from '@repo/utils';
const MINUTES_IN_MONTH = getMinutesInCurrentMonth();
const MINUTES_IN_WEEK = MINUTES_IN_DAY * 7;
export function TimeMap(param) {
    let { date, type = 'just-now' } = param;
    if (!date) return null;
    const now = new Date();
    const serverDate = new Date(date);
    if (isNaN(serverDate.getTime())) {
        return null;
    }
    if (now.getTime() < serverDate.getTime()) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    const diffInMs = now.getTime() - serverDate.getTime();
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    if (diffInMinutes < 1) {
        return /*#__PURE__*/ _jsx("span", {
            children: type === 'just-now' ? 'just now' : '0 minutes'
        });
    } else if (diffInMinutes < MINUTES_IN_HOUR) {
        return /*#__PURE__*/ _jsxs("span", {
            children: [
                diffInMinutes,
                " ",
                diffInMinutes === 1 ? 'minute' : 'minutes',
                " ago"
            ]
        });
    } else if (diffInMinutes < MINUTES_IN_DAY) {
        const diffInHours = Math.floor(diffInMinutes / MINUTES_IN_HOUR);
        return /*#__PURE__*/ _jsxs("span", {
            children: [
                diffInHours,
                " ",
                diffInHours === 1 ? 'hour' : 'hours',
                " ago"
            ]
        });
    } else if (diffInMinutes < MINUTES_IN_WEEK) {
        const diffInDays = Math.floor(diffInMinutes / MINUTES_IN_DAY);
        return /*#__PURE__*/ _jsxs("span", {
            children: [
                diffInDays,
                " ",
                diffInDays === 1 ? 'day' : 'days',
                " ago"
            ]
        });
    } else if (diffInMinutes < MINUTES_IN_MONTH) {
        const formattedDate = serverDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
        return /*#__PURE__*/ _jsx("span", {
            children: formattedDate
        });
    } else {
        const formattedDate = serverDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
        return /*#__PURE__*/ _jsx("span", {
            children: formattedDate
        });
    }
}
